var map = {
	"./music-instructions.json": 4341,
	"./music-library-intro2024.json": 4342,
	"./music-library-launch2024.json": 4343,
	"./music-progression.json": 4344,
	"./startSourcesAdvanced.json": 4345,
	"./startSourcesSimple.json": 4346,
	"./startSourcesSimple2.json": 4347,
	"./startSourcesTracks.json": 4348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4077;